import ContentPageTemplate from '@/components/ContentPageTemplate';
import PublicationsFeed from '@/components/PublicationsFeed';
import { marketingPages } from '@/data/marketingPages';

export default function PublicationsPage() {
  return (
    <ContentPageTemplate page={marketingPages.publications} after={<PublicationsFeed />} />
  );
}
